import { combineReducers } from 'redux';
import { createAction } from 'redux-actions';
import createReducer from '../../utils/redux/reducer';
import handleConsts from './handle-constants';
import constants from './constants';
import privacyPolicies from './privacyPolicies';
import appState from './app-state-req';
import countries from './countries';
import optAuthCodes from './optAuthCodes';
import countryDetails from './countryDetails';
import configurations from './configurations';
import publicConstants from './publicConstants';

export const SUCCEED = 'data/constants/SUCCEED';
export const formActions = {
  handleConsts: createAction(SUCCEED),
};

export const processedConsts = createReducer(
  {},
  {
    [SUCCEED]: handleConsts,
  },
);

export default combineReducers({
  constants,
  appState,
  countries,
  optAuthCodes,
  configurations,
  countryDetails,
  processedConsts,
  privacyPolicies,
  publicConstants,
});



// WEBPACK FOOTER //
// ./src/redux/data/index.js